<mat-toolbar class="subheader mat-elevation-z1" [class.hidden]="!showBreadcrumb && !showActions">
  <app-breadcrumb *ngIf="showBreadcrumb"></app-breadcrumb>
  <div *ngIf="!showBreadcrumb" class="spacer"></div>
  <app-topbar-actions></app-topbar-actions>
</mat-toolbar>
